import { render } from "./AllClansView.vue?vue&type=template&id=32f9ed94&scoped=true"
import script from "./AllClansView.vue?vue&type=script&lang=js"
export * from "./AllClansView.vue?vue&type=script&lang=js"

import "./AllClansView.vue?vue&type=style&index=0&id=32f9ed94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f9ed94"]])

export default __exports__